import React, { useState } from "react";

// Local slide carousel with previous/next, counter and keyboard access.
// Slides: { src, alt, caption, dish? }
export default function Carousel({ slides, label = "Gallery", className = "", renderSlide }) {
  const [index, setIndex] = useState(0);
  const count = slides.length;
  const go = (step) => setIndex((i) => (i + step + count) % count);
  const slide = slides[index];

  const onKeyDown = (e) => {
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      go(-1);
    } else if (e.key === "ArrowRight") {
      e.preventDefault();
      go(1);
    }
  };

  return (
    <div className={`ro-carousel ${className}`} role="group" aria-roledescription="carousel" aria-label={label} onKeyDown={onKeyDown}>
      <div className="ro-carousel__stage" key={index}>
        {renderSlide ? renderSlide(slide, index) : <img src={slide.src} alt={slide.alt} />}
      </div>
      <div className="ro-carousel__controls">
        <button type="button" className="ro-round" onClick={() => go(-1)} aria-label={`Previous ${label.toLowerCase()} slide`}>
          ←
        </button>
        <span className="ro-counter" aria-live="polite">
          {index + 1} / {count}
        </span>
        <button type="button" className="ro-round" onClick={() => go(1)} aria-label={`Next ${label.toLowerCase()} slide`}>
          →
        </button>
      </div>
      {slide.caption && <p className="ro-carousel__caption">{slide.caption}</p>}
    </div>
  );
}
